import { Link } from 'react-router-dom';
import { Button, Card, Badge, Alert } from '@kss/ui';
import { ExternalLink } from 'lucide-react';

export default function Demo() {
  return (
    <div className="mx-auto max-w-5xl px-6 py-16">
      <h1 className="text-4xl font-extrabold tracking-tight">Live demo</h1>
      <p className="mt-2 text-[var(--color-text-secondary)]">
        Explore the admin panel or the component showcase.
      </p>

      <Alert variant="info" className="mt-6" title="Demo credentials">
        Email <code>demo@kss.app</code>, any password — your session is stored locally.
      </Alert>

      <div className="mt-8 grid gap-4 md:grid-cols-2">
        <Card title={<span className="flex items-center gap-2">Admin Panel <Badge variant="info">live</Badge></span>}>
          <p className="text-sm text-[var(--color-text-secondary)]">
            A full dashboard with sidebar, top bar, and 18+ data widgets — the same app you'd ship to customers.
          </p>
          <div className="mt-4 flex gap-2">
            <Link to="/login"><Button>Log in</Button></Link>
            <Link to="/panel"><Button variant="outline">Skip to panel <ExternalLink className="h-3 w-3" /></Button></Link>
          </div>
        </Card>

        <Card title={<span className="flex items-center gap-2">Component showcase <Badge>tour</Badge></span>}>
          <p className="text-sm text-[var(--color-text-secondary)]">
            Every component in @kss/ui — plus the Mantine DataGrid and React Spreadsheet wrappers.
          </p>
          <div className="mt-4">
            <Link to="/sample"><Button variant="outline">Open showcase</Button></Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
